/*
道路データレイヤー用の定数
タイル描画（RoadLayer）と凡例（Legend）の両方で同じコード値・色・ラベルを使うので、
ここにまとめておいて変更が片側にしか反映されない事故を防ぐ
*/

// 画面に出すレイヤー名。レイヤートグルの内部キーとしても兼用している
export const ROAD_LAYER_NAME = "道路データ";

// 色分けモード。ユーザーがラジオボタンで切り替える。
// 道路分類種別と幅員区分の両方で色分けできるようにするための定数
export const ROAD_LAYER_MODE_CLASS = "roadClass";
export const ROAD_LAYER_MODE_WIDTH = "roadWidth";

export type RoadLayerMode =
  | typeof ROAD_LAYER_MODE_CLASS
  | typeof ROAD_LAYER_MODE_WIDTH;

// ラジオボタンから渡ってくる string を RoadLayerMode に絞り込むための型ガード
export const isRoadLayerMode = (value: string): value is RoadLayerMode =>
  value === ROAD_LAYER_MODE_CLASS || value === ROAD_LAYER_MODE_WIDTH;

// ベクタータイル内の属性キー（国土数値情報の項目名）
export const ROAD_PROPERTY_CLASS = "N13_003"; // 道路分類
export const ROAD_PROPERTY_WIDTH = "N13_006"; // 幅員区分

// コード値マップに入っていないコードが来た時のフォールバック色（正常なタイルであれば原則使われない）
export const DEFAULT_ROAD_COLOR = "#616161";

export const ROAD_CLASS_CODE_MAP: Record<string, string> = {
  "1": "国道",
  "2": "都道府県道",
  "3": "市区町村道等",
  "4": "高速自動車国道等",
  "5": "その他",
  "6": "不明",
};

export const ROAD_WIDTH_CODE_MAP: Record<string, string> = {
  "1": "3m未満",
  "2": "3m - 5.5m未満",
  "3": "5.5m - 13m未満",
  "4": "13m - 19.5m未満",
  "5": "19.5m以上",
  "6": "不明",
};

export const ROAD_CLASS_COLORS: Record<string, string> = {
  "1": "rgb(252,157,11)",
  "2": "rgb(182,12,108)",
  "3": "rgb(13,75,254)",
  "4": "rgb(255,51,14)",
  "5": "rgb(165,212,254)",
  "6": "rgb(250,246,14)",
};

export const ROAD_WIDTH_COLORS: Record<string, string> = {
  "1": "rgb(165,212,254)",
  "2": "rgb(13,75,254)",
  "3": "rgb(250,246,14)",
  "4": "rgb(252,157,11)",
  "5": "rgb(255,51,14)",
  "6": "rgb(182,12,108)",
};

// 共通タイルホスト直下のプレフィクス名
const ROAD_TILE_PATH = "road-tiles";
const ROAD_TILE_VERSION = "N13-24";

const COMMON_TILE_HOST = process.env.VITE_COMMON_TILE_HOST ?? "";
export const ROAD_TILE_HOST = COMMON_TILE_HOST
  ? `${COMMON_TILE_HOST}/${ROAD_TILE_PATH}/${ROAD_TILE_VERSION}`
  : "";
